<template>
  <div class="withdrawal">
    <van-dialog
      v-model="isVisible"
      className="dialog"
      :before-close="confirm"
      showCancelButton
      cancelButtonColor="#ccc"
    >
      <div class="dialog-title" slot="title">
        <div class="dialog-title-txt">{{ title }}</div>
      </div>
      <div class="dialog-content">
        <div>
          <div v-html="text"></div>
          <div class="amount">
            <span v-if="type ==='withdrawal'">￥</span>
            <span class="amount-number">{{ amount }}</span>
          </div>
        </div>
        <div class="form-box">
          <van-form>
            <van-field v-model="form.phoneNumber" maxlength="11" readonly>
              <div class="left-icon-box" slot="left-icon">
                <img :src="icons.phone" />
              </div>
            </van-field>
            <van-field
              v-model="form.code"
              type="number"
              maxlength="6"
              placeholder="请输入验证码"
            >
              <div class="left-icon-box" slot="left-icon">
                <img :src="icons.lock" />
              </div>
              <van-button
                class="code-btn"
                slot="button"
                size="small"
                plain
                color="#49a9f0"
                :disabled="isCodeDisabled"
                @click="getCode"
              >
                {{ isCodeDisabled ? `${timeString} 秒` : timeString }}
              </van-button>
            </van-field>
          </van-form>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
const md5 = require('md5');
const COUNTDOWN_TIME = 120;
import avatar from "@/assets/icons/avatar.png";
export default {
  props: {
    type: {
      type: String,
      default: 'binding'
    },
    amount: [String,Number],
    bindingUserName: {
      type: String,
      default: ''
    }
  },
  computed: {
    text() {
      switch(this.type) {
        case 'binding' :
          this.title = '绑定'
          return `正在绑定当前微信为提现账号！<br />请输入验证码完成绑定。`
        case 'replace' :
          this.title = '更换绑定'
          return `当前经销商已绑定${this.bindingUserName}为提现人,<br />请问是否更换当前提现人`
        case 'withdrawal' :
          this.title = '提现'
          return `正在进行提现操作!<br />请输入验证码完成提现。`
      }
    },
    is365() {
      return this.$cache.is365()
    }
  },
  watch: {
    isVisible: {
      handler(value) {
        if (!value) {
          clearTimeout(this.timer)
          this.timeString ='获取验证码';
          this.isCodeDisabled = false;
          this.form.code = ''
        }
      }
    }
  },
  data() {
    return {
      userInfo: {},
      title: '绑定',
      isVisible: false,
      avatar,
      form: {},
      icons: {
        phone: require("@/assets/icons/login_phone.png"),
        lock: require("@/assets/icons/login_lock.png"),
      },
      isCodeDisabled: false,
      timeString: "获取验证码",
    };
  },
 
  async mounted() {
    this.userInfo = await this.getBindingInfo()
    const { phone }  = this.userInfo
    let customerId = ['b0d6edfb-f4d4-41f4-b02c-7d6f522c1240','CS_JXS_B','CS_JXS_A']
    if (customerId.includes(this.$store.state.userInfo.customerId)) {
      this.form.phoneNumber = phone ?? '13678097389'
    }else {
      this.form.phoneNumber = phone
    }
  },
  methods: {
    // 获取经销商信息
    getBindingInfo() {
      return this.$api.withdrawal.getBindingInfo()
        .then(res => {
          if (!res.data) {
            return {}
          }
          return res.data
        })
    },
    onClose() {
      this.isVisible = false;
    },
    async getCode() {
      let parmes = {
        phoneNumber: this.form.phoneNumber,
        smsType: this.type != 'withdrawal' ? 1 : 2,
      };
      this.$api.withdrawal.getWithdrawalSms(parmes).then(() => {
        this.startCountdown();
      });
    },
    async confirm(action, done) {
      if (action == "confirm") {
        if (!this.form.code) {
          this.$toast('请输入验证码')
          done(false);
          return
        }
        // 绑定/更换绑定
        let request = 'bindingVerify'
        let parmes = this.form
        // 提现
        if (this.type == 'withdrawal') {
          request = 'applyWithdrawal'
          const { phoneNumber,code } = parmes
          parmes.amount = this.amount
          parmes.flag = this.is365 ? 2 : 1
          parmes.sign = md5(`phoneNumber:${phoneNumber},code:${code},amount${this.amount}s*Ua:&}~'@=$LF'cV1?e_=4B@~(+)u`)
        }
        await this.$api.withdrawal[request](parmes)
          .then(res => {
            if (res.data) {
              done()
              this.bus.$emit("bindingSuccess");
              if (this.type == 'withdrawal'){
                this.$toast('提现申请成功,款项将在24小时内转账至微信零钱！')
                setTimeout(()=> {
                  this.$router.push('/withdrawal-home')
                },2000)
              }
            }
          }).catch(err => {
            done(false);
          })
      }
      done();
    },
    startCountdown() {
      this.timeString = COUNTDOWN_TIME;
      this.countDown();
    },
    countDown() {
      this.isCodeDisabled = true;
      this.timeString = this.timeString - 1;
      if (this.timeString <= 0) {
        this.timeString = "获取验证码";
        this.isCodeDisabled = false;
        return;
      }
      this.timer = setTimeout(this.countDown, 1000);
    },
  },
};
</script>

<style lang="stylus" scoped>
.withdrawal {
  height: 100vh;
  background: #F4F4F4;
}
.inputVal
  width 30%
  border: none
  background: none;
.dialog
  border-radius: 12px
  .dialog-title
    position relative
    &-text
      text-align: center
    .close-icon
      display: inline-block
      position absolute
      right 10px
      top 0

  .dialog-content
    text-align center
    padding 0 15px
    line-height 1.4
    .amount {
      color: #FF6B31;
      font-weight: bold;
      font-size: 24px;
      .amount-number {
        font-size: 30px;
      }
    }
    >>> .van-field .van-field__value input
      color #FF6B31
  >>> .van-dialog__header
    padding 20px 0
  >>> .van-dialog__footer button

    padding 15px 0

    height: auto
    line-height 1
    color #49a9f0

  .field-item
    // margin 15px 0
    display: flex
    justify-content: space-between
    align-items: center
    padding 10px 16px
    font-size 14px
    background-color: #fff
    border-radius: 8px
    &-title
      color #323233
  .form-box
    padding 15px
    .left-icon-box
      position relative
      top 2px
      margin-right 8px
      width 22px
      height: 24px
      >img
        width 100%
        height: auto

    .input-left-icon
      line-height 33px
      // margin-right 15px
    .input-left-icon1
      // margin-right 15px
    .code-btn
      padding 0
      border none
      height: 24px
      line-height 24px
      font-size 14px
  .btn-box
    margin 20px 16px
  .tips-content
    color #777
    font-size 12px
    line-height 18px
  .block-btn
    border-radius: 25px
    font-size 16px
    color #FFF
    background linear-gradient(#FF8820, #FF6B31)

  .success-box
    padding 15px
    .info-box
      padding 15px 0
      text-align: center
      >div
        margin-top 15px
.ft24
  font-size:24px;
  font-weight: bold;
  color:#000
</style>
